import React from 'react';
import ButtonContainer from '../ButtonContainer';

const Error = () => {
	return (
		<section className="lhp-main error">
			<h2>Der er desværre sket en fejl</h2>
			<p>Tryk på nedenstående knap for at genindlæse.</p>
			<ButtonContainer m-m_medium>
				<a href="/" className="btn">Tilbage</a>
			</ButtonContainer>
		</section>
	);
};

export default Error;